import { Common } from '@thecvlb/design-system/lib/src';
import HTMLReactParser from 'html-react-parser';

import { MifInfoProps } from './mifInfo.types';

const MifInfo: React.FC<MifInfoProps> = ({ onContinue, name, description }) => {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-col items-center gap-2 py-6 text-center">
        <Common.Icon
          className="mx-auto size-[96px] flex-none rounded-full bg-secondary-100 p-8 text-secondary"
          name="list-outline-simple"
        />
        <h4 className="text-m2xl font-bold text-primary-700 md:text-2xl">{name}</h4>
        {HTMLReactParser(description || '')}
        <Common.Alert type="info">
          <p className="text-left">
            Make sure to select all that apply to help your provider select the appropriate
            medication.
          </p>
        </Common.Alert>
      </div>
      <Common.Button
        className="py-6 max-md:mt-auto md:self-center"
        color="blue"
        fullWidthOnMobile
        onClick={onContinue}
      >
        Continue to survey (~1 min)
      </Common.Button>
    </div>
  );
};

export default MifInfo;
